import { Injectable } from "@angular/core";
import { tap } from "rxjs/operators";
import { Router } from '@angular/router';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { CommonService } from './services/common.service';

@Injectable()
export class UserInterceptor implements HttpInterceptor {

  constructor(private router: Router, private commonService: CommonService) { }

  //function which will be called for all http calls
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    //how to update the request Parameters
    // const updatedRequest = request.clone({
    //   headers: request.headers.set("Authorization", "Some-dummyCode")
    // });
    return next.handle(request).pipe(
      tap(event => {
          if(event instanceof HttpResponse) {
            if(event.body && event.body.session_end) {
              localStorage.clear();
              sessionStorage.clear();
              window.location.reload();
            }
            if(event.body?.status && this.isStorefrontPublish(request)) {
              this.commonService.showToast('Saved. Storefront cache is refreshing; live site updates shortly.', false, 4500);
            }
          }
        },
        error => { }
      )
    );
  }

  private isStorefrontPublish(request: HttpRequest<any>) {
    if(['POST', 'PUT', 'PATCH'].indexOf(request.method) === -1) return false;
    const url = request.url || '';
    if(url.indexOf('/store/storefront/revalidate') !== -1) return false;
    return [
      '/store/product',
      '/store/catalog',
      '/store/layout',
      '/store/layout_list',
      '/store/layout_list_v2',
      '/store/menu',
      '/store/footer_seo_links',
      '/store/blog',
      '/store/article',
      '/store/ad',
      '/store/details',
      '/store/properties',
      '/store/update_logo'
    ].some(path => url.endsWith(path) || url.indexOf(path + '/') !== -1);
  }
  
}